import React from 'react'
import  '../Footer.css'
function Footer() {
  return (
    <div id='foot'>
        <p>Thanks for visiting our Website .</p>
         <p>Work is under process , Contact our creator Mr Tushar M</p>
         <p>All CopyRight Reserved Under  WWW.FOOD ZONE.in ....</p>
    </div>
  )
}

export default Footer